import request from '@/utils/request'

// 查询银行列表
export function listBank(query) {
  return request({
    url: '/user/bank/list',
    method: 'get',
    params: query
  })
}

// 查询银行分页
export function pageBank(query) {
  return request({
    url: '/user/bank/page',
    method: 'get',
    params: query
  })
}

// 查询银行详细
export function getBank(data) {
  return request({
    url: '/user/bank/detail',
    method: 'get',
    params: data
  })
}

// 新增银行
export function addBank(data) {
  return request({
    url: '/user/bank/add',
    method: 'post',
    data: data
  })
}

// 修改银行
export function updateBank(data) {
  return request({
    url: '/user/bank/edit',
    method: 'post',
    data: data
  })
}

// 删除银行
export function delBank(data) {
  return request({
    url: '/user/bank/delete',
    method: 'post',
    data: data
  })
}
